import { SourceType } from "../../../models/channel";

export const allSourceTypeOptions: Array<{ id: SourceType; name: string }> = [
  { id: 'RTMP Source', name: 'RTMP or SRT' },
  { id: 'HLS Source', name: 'HLS Source' },
];
